import axios from "axios";
import { useEffect, useState } from "react";


export function useData() {
    const [data, setData] = useState([])
    const [loading, setIsLoading] = useState([])
    const [isFinished, setIsFinished] = useState(false)


    function fetch(is_mounted = true, page = 0) {

        setIsLoading(true)
        axios.get(`user/list-user-active?page=${page}`)
            .then(res => {
                if (!is_mounted) return
                setData(prev => [...prev, ...res.data])

                if (res.data.length == 0) {
                    setIsFinished(true)
                }

            }).finally(() => {
                setIsLoading(false)
            })
    }

    function findUser(name) {
        axios.get(`user/list-user-active?page=0&name=${name}`)
            .then(res => {
                setData(res.data)
            })
    }

    useEffect(() => {

        let is_mounted = true
        fetch(is_mounted)

        return () => {
            is_mounted = false
        }

    }, [])


    return {
        data,
        fetch,
        findUser,
        isFinished,
        loading,
        setIsFinished
    }
}